// extracted by css-extract-rspack-plugin
export default {"resizableBox":"wNNjC","noSelect":"FkjYh"};